angular.module('BookingApp').value('AppTraffic', {})
